// Port of api/fuel/app/classes/insights/plays/years.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'years',
    insight: ['year'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_plays()) return {}

        var limit = detail ? 100000 : 25
        var range = this.get_period_date_range(type, owner, filter)
        var players = filter.players || 0
        var sqlCount = players ? ' AND p.play_players = ' + players : ''

        var year_type = filter.year || 'version'

        var years = {}

        var currentYear = new Date().getUTCFullYear()

        for (var y = currentYear; y > currentYear - limit; y--) {
            years[y] = {
                year: y,
                count: 0
            }
        }

        var collectionIndex = Util.queryFast(
            'SELECT g.game_published AS gy,' +
            ' SUM(p.play_count) AS pc' +
            ' FROM play p' +
            ' JOIN game g ON p.game_id = g.game_id' +
            ' WHERE p.user_id IN(' + Util.in(userIndex) + ')' +
            ' AND p.play_date >= ' + range.start +
            ' AND p.play_date <= ' + (range.end - 1) +
            ' AND g.game_type = 1' +
            sqlCount +
            ' GROUP BY g.game_id'
        )

        var earliestYear = detail ? currentYear : currentYear - limit

        for (var i = 0; i < collectionIndex.length; i++) {
            var item = collectionIndex[i]
            var yr = item.gy ? parseInt(item.gy, 10) : 0

            if (years[yr]) {
                years[yr].count += parseInt(item.pc, 10)
            }

            if (earliestYear > yr && (!detail || (detail && yr > currentYear - limit))) {
                earliestYear = yr
            }
        }

        // Convert to array and sort by year ascending
        var yearsArray = []
        var yearKeys = Object.keys(years)
        for (var ki = 0; ki < yearKeys.length; ki++) {
            yearsArray.push(years[yearKeys[ki]])
        }
        yearsArray = Util.sort_by_field(yearsArray, 'year', 'desc')

        // Filter to relevant years
        yearsArray = yearsArray.filter(function(yr) {
            return yr.year >= earliestYear && (yr.count > 0 || yr.year > (currentYear - 25))
        })

        return {
            years: yearsArray,
            moreYears: (!detail && earliestYear < currentYear - limit) ? true : false
        }

    }
})
